import {RootStore} from '../../stores/RootStore';

export const getIsViewer = (rootStore: RootStore): boolean => {
  return rootStore.controllerParams.flowAPI.environment.isViewer;
};
